import { render, staticRenderFns } from "./add-production.vue?vue&type=template&id=158805e2"
import script from "./add-production.vue?vue&type=script&lang=ts"
export * from "./add-production.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports